import { render, staticRenderFns } from "./TheSiteFooter.vue?vue&type=template&id=341fafbb&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('341fafbb')) {
      api.createRecord('341fafbb', component.options)
    } else {
      api.reload('341fafbb', component.options)
    }
    module.hot.accept("./TheSiteFooter.vue?vue&type=template&id=341fafbb&", function () {
      api.rerender('341fafbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/layouts/partials/TheSiteFooter.vue"
export default component.exports